export const DAYS = 'days';
export const DAY = 'day';
export const MONTH = 'month';
export const DATE = 'date';

export const TEXT_RENDERER_STYLES = { height: '100%', padding: '0px' };
